<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import moment from "moment";
  import { productContainerDetailsShort } from "@shared/filters/product_container_details.js";
  import type { Product, ProductLine } from "@shared/types/ProductLine";
  import PricingSchedulePrices from "@retailer/svelte/ProductDetails/Components/PricingSchedulePrices.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  export let showPricingModal: boolean = false;
  export let product: Product;
  export let productLine: ProductLine;
  export let pricingForProduct: any;
  export let onCloseModal: () => void = () => {};

  // Typescript doesn't like the root "moment()" function
  // @ts-ignore
  const month = moment().month();
  // @ts-ignore
  const currentMonth = moment().month(month).format("MMMM");
  // @ts-ignore
  const nextMonth = moment()
    .month(month + 1)
    .format("MMMM");
  // @ts-ignore
  const lastMonth = moment()
    .month(month - 1)
    .format("MMMM");

  function closeModal() {
    showPricingModal = false;
    onCloseModal();
  }
</script>

<div>
  <Modal
    bind:show={showPricingModal}
    fizzModal={true}
    medium={true}
    overflow="auto"
    onClose={onCloseModal}
  >
    <header class="fizz-modal-header">
      <h4 class="fizz-heading-4">Price schedule</h4>
      <div class="fizz-modal-toggle fizz-modal-close" on:click={closeModal}>
        <Icon
          type="X"
          extraClassNames="fizz-text-brand cursor-pointer"
          height="16"
          width="16"
          id="close-future-prices"
        />
      </div>
    </header>
    <section class="fizz-inset-horizontal-24 fizz-stack-32">
      <div class="fizz-inset-square-16 fizz-bordered-squared fizz-surface-gray">
        <p class="fizz-heading-5">{productLine.name}</p>
        <p>{product.container_size} {product.container_units} {product.container_type}</p>
        <p>{productContainerDetailsShort(product)}</p>
      </div>
      <div class="fizz-inset-square-16 fizz-text-small fizz-border-left fizz-border-right">
        <p class="fizz-text-eyebrow fizz-text-uppercase fizz-stack-4">
          {currentMonth} (CURRENT)
        </p>
        <PricingSchedulePrices {product} {productLine} prices={pricingForProduct.current_prices} />
      </div>
      <div
        class="fizz-inset-square-16 fizz-text-small fizz-border-left fizz-border-right fizz-border-top"
        data-testid="next-month-prices"
      >
        <p class="fizz-text-eyebrow fizz-text-uppercase fizz-stack-4">
          {nextMonth} (NEXT)
        </p>
        <PricingSchedulePrices
          {product}
          {productLine}
          priceChanges={pricingForProduct.price_changes_by_tier}
          prices={pricingForProduct.future_prices}
        />
      </div>
      {#if !stagedRolloutCheck("marketplace__hide_past_prices")}
        <div
          class="fizz-inset-square-16 fizz-text-small fizz-border-left fizz-border-right fizz-border-top"
          data-testid="previous-month-prices"
        >
          <p class="fizz-text-eyebrow fizz-text-uppercase fizz-stack-4">
            {lastMonth} (LAST)
          </p>
          <PricingSchedulePrices {product} {productLine} prices={pricingForProduct.past_prices} />
        </div>
      {/if}
    </section>
  </Modal>
</div>
